export const objToEncodedURI = (obj: Record<string, string | number | boolean>) => Object.entries(obj)
  .map(
    ([paramKey, paramValue]) => `${encodeURIComponent(paramKey)}=${encodeURIComponent(paramValue)}`,
  )
  .join('&');
